import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";

import { ChangeEvent } from "utils/history/Event";

import { BooleanField } from "../FieldService";
import {
	InformationRight,
	InformationRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";

export type BooleanInputProps = {
	field: BooleanField;
	editable: boolean;
	rights: InformationRights;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const BooleanInput: React.FC<BooleanInputProps> = (
	props: BooleanInputProps
) => {
	function onChange(newValue: boolean): void {
		const change = new ChangeEvent("/value", props.field.value, newValue);
		props.onChange(change, true);
	}

	return (
		<Grid
			item
			container
			xs={12}
			md={6}
			columnSpacing={2}
			alignItems="center">
			<Grid item xs={12} sm={6}>
				<Typography variant="subtitle2" sx={{ wordWrap: "break-word" }}>
					{props.field.name}
					{props.field.required && " *"}
				</Typography>
			</Grid>
			<Grid item xs={12} sm={6}>
				<Checkbox
					sx={{ marginLeft: -1.5 }}
					id={props.field.name}
					disabled={
						!props.editable ||
						!props.rights[props.field.uuid][InformationRight.WRITE]
					}
					checked={props.field.value}
					onChange={event => onChange(event.target.checked)}
				/>
			</Grid>
		</Grid>
	);
};

export default BooleanInput;
